import * as types from './mutations_types.js'

export const state = {
  cartlist: [],
  activityitem: [],
  checkoutStatus: null
}

export const mutations = {
  [types.ADD_TO_CART] (state, data) {
    let record = ''
    let fid = ''
    if (state.cartlist.length > 0) {
      record = state.cartlist.find(p => p.id === data.id)
      fid = state.cartlist.find(p => p.fid === data.fid)
    }
    if (fid || fid === '') {
      if (!record) {
        let temp = {
          id: data.id,
          name: data.name,
          price: data.price,
          point: data.point,
          quantity: data.quantity,
          fid: data.fid,
          imageL: data.imageL,
          maximum: 20
        }
        state.cartlist.push(temp)
      } else {
        if (data.quantity < record.quantity) {
          if (data.quantity > 1) {
            record.quantity += data.quantity
          } else {
            record.quantity++
          }
        }
      }
      window.localStorage.setItem('cart', JSON.stringify(state.cartlist))
    } else {
      window.alert('請先結帳後再進行其他店家的購物')
    }
  },
  [types.SAVE_TO_CART] (state, data) {
    state.cartlist = data
  },
  [types.SAVE_ACTIVITY_ITEM] (state, data) {
    state.activityitem.push(data)
    window.localStorage.setItem('activityitem', data)
  },
  [types.EDIT_TO_CART] (state, data) {
    // console.log(data)
    state.cartlist = data
    window.localStorage.setItem('cart', JSON.stringify(state.cartlist))
  },
  [types.DELETE_TO_CART] (state, data) {
    // const record = state.cartlist.find(p => p.id === data.id)
    state.cartlist.splice(state.cartlist.indexOf(data), 1)
    // console.log(state.cartlist)
    window.localStorage.setItem('cart', JSON.stringify(state.cartlist))
  },
  [types.CHECKOUT] (state, data) {
    localStorage.setItem('cart', [])
    state.cartlist = []
  }
}



// WEBPACK FOOTER //
// ./src/store/cart/mutations.js